"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.sendGxStepAnswer = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _qs = _interopRequireDefault(require("qs"));
_axios.default.defaults.paramsSerializer = params => _qs.default.stringify(params, {
  arrayFormat: 'brackets'
});

/**
 * Guided Experience V2
 * @param {Object} props
 * @param {String} props.answer
 * @param {String} props.providerId
 * @param {String} props.csrfToken
 * @param {Number} props.stepId
 *
 * @returns {Object} response from booking call
 */
const sendGxStepAnswer = async _ref => {
  let {
    answer,
    providerId,
    protocolId,
    stepId,
    csrfToken,
    context,
    productName
  } = _ref;
  const headers = {
    'x-csrf-header': csrfToken
  };
  if (productName) {
    headers['x-consumer-username'] = productName;
  }
  const body = {
    answer_value: answer,
    provider_id: providerId,
    ...(context && {
      context
    })
  };
  const res = await _axios.default.post(`/api/gx/protocol/${protocolId}/node/${stepId}`, body, {
    headers
  });
  return res.data;
};
exports.sendGxStepAnswer = sendGxStepAnswer;